var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8466_90879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.25 10H21.25L16.982 5.73203C16.7498 5.4999 16.4742 5.31577 16.1709 5.19017C15.8675 5.06457 15.5424 4.99995 15.2141 5H3.75C2.75544 5 1.80161 5.39509 1.09835 6.09835C0.395088 6.80161 0 7.75544 0 8.75L0 31.25C0 32.2446 0.395088 33.1984 1.09835 33.9017C1.80161 34.6049 2.75544 35 3.75 35H36.25C37.2446 35 38.1984 34.6049 38.9016 33.9017C39.6049 33.1984 40 32.2446 40 31.25V13.75C40 12.7554 39.6049 11.8016 38.9016 11.0983C38.1984 10.3951 37.2446 10 36.25 10ZM36.25 31.25H3.75V8.75H14.6969L18.9648 13.018C19.197 13.2501 19.4727 13.4342 19.776 13.5598C20.0794 13.6854 20.4045 13.7501 20.7328 13.75H36.25V31.25Z",
    fill: "#335C75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8466_90879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon-folder.9373c5ae8d8e495e22044028956ee4e2.svg";
export { ForwardRef as ReactComponent };